var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 27C24.7614 27 27 24.7614 27 22C27 19.2386 24.7614 17 22 17C19.2386 17 17 19.2386 17 22C17 24.7614 19.2386 27 22 27Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.316 53.9996L59.0002 46.9996L41.4198 29.4197C41.7982 28.0104 42 26.5287 42 25C42 15.6112 34.3888 8 25 8C15.6112 8 8 15.6112 8 25C8 34.3888 15.6112 42 25 42C26.5288 42 28.0105 41.7982 29.4198 41.4198L34.0001 45.9997L36 43.9997L46.0002 53.9996H56.316ZM37.5566 28.3824L36.9574 30.6142L54.3357 47.992L53.5658 49.9996H47.6571L36 38.3429L34 40.3429L30.6142 36.9574L28.3826 37.5566C27.3084 37.845 26.1754 38 25 38C17.8203 38 12 32.1797 12 25C12 17.8203 17.8203 12 25 12C32.1797 12 38 17.8203 38 25C38 26.1753 37.845 27.3083 37.5566 28.3824Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.8b3d49e1dc1a4e8cb2587acb1387be62.svg";
export { ForwardRef as ReactComponent };